import { render, staticRenderFns } from "./ArticleSeoAdvancedStep.vue?vue&type=template&id=473ffd3c&"
import script from "./ArticleSeoAdvancedStep.vue?vue&type=script&lang=js&"
export * from "./ArticleSeoAdvancedStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports